import styled from 'styled-components/macro'

export const Wrapper = styled.div`
  .page {
    animation: none;
    transform: unset;
  }

  form {
    max-width: min(calc(100vw - 32px), 450px);

    button {
      align-self: center;
      margin-top: 24px !important;
    }
  }

  .input-field {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;

    input {
      width: 100%;
      padding-right: 40px;
    }

    .toggle-password {
      position: absolute;
      right: 12px;
      color: ${props => props.theme.secondaryText};
      cursor: pointer;
      font-size: 16px;

      &:hover {
        color: ${props => props.theme.accent};
      }
    }
  }

  .bottom-buttons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: 30px;

    @media (min-width: 768px) {
      margin-bottom: -24px;
    }

    .small-separator {
      border-right: 1px solid ${props => props.theme.accent};
      height: 16px;
      margin: 0 16px;
    }

    button {
      margin: 0;
      margin-top: 0 !important;
      padding: 0;
      flex: 1;
    }
  }

  .centered {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .or-line {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
    margin-bottom: 16px;

    .line {
      width: 50px;
      margin: 0 8px;
      border-top: 1px solid ${props => props.theme.border};
    }
  }
`
